import styles from "./RequestProgressScan.module.scss";
import React, { useState } from 'react';
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { RequestProgressScanForm } from '../../components/RequestProgressScanForm';
import { useQuery } from '@apollo/client';
import { ASSESSMENTS_ROUTES } from '../../apollo/queries';
import { AssessmentRoute } from '../../apollo/types/AssessmentRoute';

export const RequestProgressScan = () => {
    const [assessmentRoutes, setAssessmentRoutes] = useState<[AssessmentRoute] | []>([]);
    useQuery(ASSESSMENTS_ROUTES, {
        onCompleted: (someData) => {
            setAssessmentRoutes(someData.myAssessmentRoutes)
        }
    });
  return (
    <div className={styles.wrapper}>
      <GreetingsHeader title='Request Progress Scan' subtitle='' />
        {assessmentRoutes.length > 0 &&
            <RequestProgressScanForm routes={assessmentRoutes}/>
        }
    </div>
  );
};
